var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAccordion(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 4,
    viewBox: "0 0 7 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.31.888V.664H4.77L3.412 2.316h-.224L1.83.664H.29v.224l2.8 2.94h.42l2.8-2.94z",
    fill: "#25241D"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNyIgaGVpZ2h0PSI0IiB2aWV3Qm94PSIwIDAgNyA0IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBkPSJNNi4zMSAwLjg4Nzk5OUw2LjMxIDAuNjYzOTk5TDQuNzcgMC42NjM5OTlMMy40MTIgMi4zMTZMMy4xODggMi4zMTZMMS44MyAwLjY2Mzk5OUwwLjI4OTk5OSAwLjY2NEwwLjI4OTk5OSAwLjg4OEwzLjA5IDMuODI4TDMuNTEgMy44MjhMNi4zMSAwLjg4Nzk5OVoiIGZpbGw9IiMyNTI0MUQiLz4KPC9zdmc+Cg==";
export { SvgAccordion as ReactComponent };